// colors.js
export const colors = {
  primaryGreen: "#53BA4D",
  primaryGreenHover: "#60d65aff",
  primaryRed: "#71706E",
  primaryRedHover: "#818180ff",
};
